<template>
  <div class="full-chart-container">
    <div class="chart">
      <div class="y-axis">
        <div class="scale-label label1">{{maximumYvalue / 3}}</div>
        <div class="scale-label label2">{{(maximumYvalue * 2) / 3}}</div>
        <div class="scale-label label3">{{maximumYvalue}}</div>
      </div>
      <div class="bars-container">
        <div class="scale-line scale-line1"></div>
        <div class="scale-line scale-line2"></div>
        <div :style="{height: stronglyAgreeBarHeight()}" class="bar blue">
          <div class="bar-label">{{responses.strongly_agree}}</div>
        </div>
        <div :style="{height: agreeBarHeight()}" class="bar green">
          <div class="bar-label">{{responses.agree}}</div>
        </div>
        <div :style="{height: neutralBarHeight()}" class="bar yellow">
          <div class="bar-label">{{responses.neutral}}</div>
        </div>
        <div :style="{height: disagreeBarHeight()}" class="bar orange">
          <div class="bar-label">{{responses.disagree}}</div>
        </div>
        <div :style="{height: stronglyDisagreeBarHeight()}" class="bar red">
          <div class="bar-label">{{responses.strongly_disagree}}</div>
        </div>
      </div>
    </div>
    <div class="legend">
      <div class="legend-sub-container">
        <div class="legend-box blue"></div>
        <div class="legend-label">Strongly Agree</div>
      </div>
      <div class="legend-sub-container">
        <div class="legend-box green"></div>
        <div class="legend-label">Agree</div>
      </div>
      <div class="legend-sub-container">
        <div class="legend-box yellow"></div>
        <div class="legend-label">Neutral</div>
      </div>
      <div class="legend-sub-container">
        <div class="legend-box orange"></div>
        <div class="legend-label">Disagree</div>
      </div>
      <div class="legend-sub-container">
        <div class="legend-box red"></div>
        <div class="legend-label">Strongly Disagree</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    question: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      responses: {
        strongly_agree: 0,
        agree: 0,
        neutral: 0,
        disagree: 0,
        strongly_disagree: 0
      },
      maximumYvalue: 30
    };
  },
  methods: {
    stronglyAgreeBarHeight() {
      return `${(this.responses.strongly_agree / this.maximumYvalue) * 100}%`;
    },
    agreeBarHeight() {
      return `${(this.responses.agree / this.maximumYvalue) * 100}%`;
    },
    neutralBarHeight() {
      return `${(this.responses.neutral / this.maximumYvalue) * 100}%`;
    },
    disagreeBarHeight() {
      return `${(this.responses.disagree / this.maximumYvalue) * 100}%`;
    },
    stronglyDisagreeBarHeight() {
      return `${(this.responses.strongly_disagree / this.maximumYvalue) *
        100}%`;
    },
    countOfMode() {
      return Math.max(
        this.responses.strongly_agree,
        this.responses.agree,
        this.responses.neutral,
        this.responses.disagree,
        this.responses.strongly_disagree
      );
    },
    setMaximumYValue() {
      let maxY = 30;
      while (this.countOfMode() > maxY) {
        maxY += 30;
      }
      this.maximumYvalue = maxY;
    },
    mapResponses() {
      this.question.responses.forEach(resp => {
        switch (resp.Comment) {
          case "Strongly Agree":
            this.responses.strongly_agree++;
            return;
          case "Agree":
            this.responses.agree++;
            return;
          case "Neutral":
            this.responses.neutral++;
            return;
          case "Disagree":
            this.responses.disagree++;
            return;
          case "Strongly Disagree":
            this.responses.strongly_disagree++;
            return;
          default:
            return;
        }
      });
    }
  },
  created() {
    this.mapResponses();
    this.setMaximumYValue();
  }
};
</script>

<style scoped>
/* CHART STYLING MOBILE */
.full-chart-container {
  display: flex;
  align-items: space-between;
  flex-wrap: wrap;
  min-height: 16em;
  margin-top: 1em;
}
.chart {
  width: 16em;
  height: 12em;
  margin: 0.5em 0.5em 0em 0.5em;
  display: flex;
}
.y-axis {
  width: 2em;
  height: 100%;
  position: relative;
  font-size: 0.75em;
}
.scale-label {
  position: absolute;
  font-family: Arial, Helvetica, sans-serif;
}
.label1 {
  top: calc((100% / 1.5) - 0.5em);
}
.label2 {
  top: calc((100% / 3) - 0.5em);
}
.label3 {
  top: -0.5em;
}
.bar-label {
  position: absolute;
  font-size: 0.75em;
  font-family: Arial, Helvetica, sans-serif;
  top: -1.25em;
  width: 100%;
  text-align: center;
}
.bars-container {
  border: 1px solid #979797;
  width: 90%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  position: relative;
}
.scale-line {
  position: absolute;
  width: 100%;
  height: 2px;
  opacity: 0.8;
  background-color: #979797;
}
.scale-line1 {
  top: calc(100% / 3);
}
.scale-line2 {
  top: calc(100% / 1.5);
}

.bar {
  width: 1em;
  position: relative;
}
.legend {
  width: 3em;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 15em;
  font-size: 0.65em;
  margin-top: 0.75em;
  margin-left: 0.5em;
}
.legend-label {
  width: 2em;
  display: flex;
  flex-wrap: wrap;
}
.legend-sub-container {
  display: flex;
  align-items: center;
  min-width: 10em;
  height: 1.5em;
  font-family: Arial, Helvetica, sans-serif;
}
.legend-box {
  margin-right: 0.25em;
}
.legend-box {
  width: 1.5em;
  height: 1.5em;
}
.red {
  opacity: 0.8;
  background-color: #d0021b;
}
.orange {
  opacity: 0.8;
  background-color: #f5a623;
}
.yellow {
  opacity: 0.8;
  background-color: #f8e71c;
}
.green {
  opacity: 0.81;
  background-color: #417505;
}
.blue {
  opacity: 0.8;
  background-color: #1367ca;
}
@media only screen and (min-width: 1200px) {
  .chart {
    width: 50em;
    height: 15em;
    margin: 0.5em 0.5em 0em 0.5em;
    display: flex;
  }
  .bar {
    width: 3em;
    position: relative;
  }
  .legend {
    width: 10em;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 15em;
    font-size: 0.65em;
    margin-top: 0.75em;
    margin-left: 0.5em;
    font-size: 1em;
  }
  .legend-label {
    width: 4em;
    display: flex;
    flex-wrap: wrap;
  }
  .legend-sub-container {
    display: flex;
    align-items: center;
    min-width: 10em;
    height: 1.5em;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 1.1em;
  }
  .legend-box {
    margin-right: 0.25em;
  }
  .legend-box {
    width: 1.5em;
    height: 1.5em;
  }
}
</style>